class InitialDataService {
  constructor($http, AuthenticationService, $state, vacationUserDataService, vacationEmployeeRepositoryService) {
    'ngInject';
    this.$http = $http;
    this.employeeRepositoryService = vacationEmployeeRepositoryService;
    this.state = $state;
    this.userDataService = vacationUserDataService;
    this.year = new Date().getFullYear();
    this.employeeId = AuthenticationService.getEmployeeId();
  }

  initMainData() {
    return this.employeeRepositoryService.getEmployee(this.employeeId, this.year)
    .then((employee) => {
      this.userDataService.setEmployee(employee);
      this.manager = employee.isManager();
      this.hasDelegation = employee.hasDelegation();
      return employee;
    });

  }
}

export default InitialDataService;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/initialData/initialData.service.js